
module.config(function($stateProvider) {

    $stateProvider.state('program.users', {
        templateUrl: 'programs/users/page',
        url: '/users',
        permission: 'viewUsers',

        resolve: {
            users: function(UserService, program) {
                return UserService.getProgramUsers(program.id, 'users');
            },
        },

        controllerAs: 'ctrl',
        controller: module.cC({
            inject: ['users'],
        }),
    });
});


function editProgramUserForm(makeBasicForm, userAccessLevels, UserService) {
    return makeBasicForm({
        templateUrl: 'programs/users/editProgramUserForm',
        scope: {user: '=', program: '=', canDelete: '=', allUsers: '='},
        data: {userAccessLevels: userAccessLevels, editing: true},
        copyData: function(scope) {
            return {
                access_level: scope.user.access_level,
                is_director: scope.user.is_director,
            };
        },
        save: function(scope, data) {
            return UserService.updateProgramUser(scope.program.id, scope.user.id, data)
                .then(function(user) {angular.copy(user, scope.user);});
        },
        delete: function(scope) {
            return UserService.removeProgramUser(
                scope.program.id, scope.user.id).then(function() {
                    var index = scope.allUsers.indexOf(scope.user);
                    if (index >= -1) {
                        scope.allUsers.splice(index, 1);
                    }
                })
        },
        canDelete: function(scope) {
            return scope.canDelete;
        },
    });
}

function newProgramUserForm($q, makeBasicForm, userAccessLevels, UserService) {
    return makeBasicForm({
        templateUrl: 'programs/users/editProgramUserForm',
        scope: {program: '=',  allUsers: '='},
        data: {userAccessLevels: userAccessLevels, editing: false},
        save: function(scope, data) {
            return UserService.newProgramUser(scope.program.id, data)
                .then(scope.allUsers.push.bind(scope.allUsers));
        },
        link: function(scope) {
            var watcher = scope.$watch('form.email', function(ngModel) {
                ngModel.$asyncValidators.userEmail =
                    searchForEmail($q, UserService, scope);
            })
        },
    });
}

function searchForEmail($q, UserService, scope) {
    return function(email) {
        if (!email) {
            scope.match = {};
            return $q.when(true);
        }
        return UserService.emailSearch(scope.program.id, email)
            .then(function(match) {
                scope.match = match;
                if (match.is_coach || match.is_staff) {
                    return $q.reject();
                }
            });
    }
}

module.directive('newProgramUserForm', newProgramUserForm);
module.directive('editProgramUserForm', editProgramUserForm)